<template>
	<div class="login-view">
        No access
	</div>
</template>

<script>
export default {
    name: 'NoAccessView',
    
    data() {
        return {
         
        }
    },

    methods: {
      
    }
}
</script>

<style lang="stylus" scoped>
.world-view 
    border 1px solid black
    display flex
    flex-direction column

</style>



// WEBPACK FOOTER //
// src/views/NoAccessView.vue